<!--<head>
  <meta name="viewport" content= "width=device-width, initial-scale=1.0">
</head>-->

<div class="main-container" style="background-color: #ffffff;">
  <div class="container" style= "min-height:600px; background-color: #ffffff; margin-top: 10px;">
    <div class="row" >
      <div class="col">
        <div style="border-bottom: 1px solid #B8B0B0; padding-left: 5px; padding-right: 5px;">
          <h1 style="font-size: 22px;color: #14274e;width: auto;margin-top: 20px;">
            All Services
          </h1>
          <button class="btn btn-primary" type="button" (click)="clickAddNewProduct()" [disabled]="showAddNewProductForm" style="float: right;background-color: #ffffff;font-size: 14px;color: #14274e;margin-top: -45px;border-color: #14274E;">
            Add New
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class= "dexterGrid" style="margin-top:20px;">
          <ag-grid-angular
            style="height: 250px; width: 100%;"
            class="ag-theme-alpine"
            [rowData]="rowData"
            [columnDefs]="columnDefs"
            (gridReady)="onGridReady($event)"
            (rowClicked)="onRowClicked($event)">
          </ag-grid-angular>
        </div>
      </div>
    </div>

    <div *ngIf="showUpdateProductForm">
      <div *ngIf="successMessage" style="color: green; font-weight: bold; margin-top: 15px;">
        {{ successMessage }}
      </div>
      <div class="row" style="margin-top: 20px;">
        <div class="col">
          <form [formGroup]="updateproductFormGroup">
            <div class="form-group">
              <div>
                <p class= "admin-string-primary" style="margin-top: 20px;">
                  EDIT SERVICE
                  <button class="btn btn-primary" (click)="onUpdateProductFormSaveClicked()" type="button" style="background-color: #ffffff;color: #7c7575;width: 66px;height: 30px;padding: 0px;font-size: 14px;float: right;margin-right: 0px;border-color: #14274E;">
                    Save
                  </button>
                  <button class="btn btn-primary" (click)="onUpdateProductFormCancelClicked()" type="button" style="background-color: #ffffff;color: #14274e;width: 66px;height: 30px;padding: 0px;font-size: 14px;float: right;margin-right: 30px;border: none;border-color: #14274E;">
                    Cancel
                  </button>
                </p>
                <hr style="background-color: #D8DFE6;" />
              </div>
              <div class="row">
                <div class="col">
                  <div>
                    <div style="float: left;margin-right: 100px;">
                      <label style="font-size: 11px;height: 15px;padding-top: 0px;padding-bottom: 0px;color: #7c7575;font-weight: bold;" for="update-product-name">
                        SERVICE NAME
                      </label>
                      <input type="text" id="update-product-name" class="form-control" formControlName="updateProductNameFormControl" placeholder="Service Name"
                             style="width: 350px;height: 40px;" />
                      <div *ngIf="updateProductFormControls.updateProductNameFormControl.hasError('required') && updateProductFormControls.updateProductNameFormControl.touched" style="color: red;font-size: 14px;">
                        Service Name is required.
                      </div>
                    </div>

                    <div style="float: left;margin-right: 100px;">
                      <label style="font-size: 11px;height: 15px;padding-top: 0px;padding-bottom: 0px;color: #7c7575;font-weight: bold;" for="update-product-description">
                        SERVICE DESCRIPTION
                      </label>
                      <textarea id="update-product-description" class="form-control" formControlName="updateProductDescriptionFormControl" placeholder="Service Description" rows="2"
                                style="width: 350px;">
                                        </textarea>
                      <div *ngIf="updateProductFormControls.updateProductDescriptionFormControl.hasError('required') && updateProductFormControls.updateProductDescriptionFormControl.touched" style="color: red;font-size: 14px;">
                        Service Description is required.
                      </div>
                    </div>

                    <div style="float: left;" *ngIf="!isClickedAddOn()">
                      <label class="field-label" for="update-service-type">
                        SERVICE TYPE <span class="required-star">*</span>
                      </label>
                      <select id="update-service-type" formControlName="updateServiceTypeFormControl" class="form-control service-type-select">
                        <option value="">-- Select --</option>
                        <option *ngFor="let service of serviceTypes" [value]="service.value">{{ service.label }}</option>
                      </select>
                      <div class="validation-error" *ngIf="updateProductFormControls.updateServiceTypeFormControl.hasError('required') && updateProductFormControls.updateServiceTypeFormControl.touched">
                        Service Type is required.
                      </div>
                    </div>
                    <!-- <div style="float: left;">
                        <label style="font-size: 11px;height: 15px;padding-top: 0px;padding-bottom: 0px;color: #7c7575;font-weight: bold;" for="product-id">
                            PRODUCT ID
                        </label>
                        <input disabled type="text" id="product-id" class="form-control" placeholder="Product ID"
                            style="width: 350px;height: 40px;" />
                    </div> -->
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div style="margin-top: 20px;">
                    <div style="float: left;margin-right: 100px;">
                      <label style="font-size: 11px;height: 15px;padding-top: 0px;padding-bottom: 0px;color: #7c7575;font-weight: bold;" for="update-product-rate">
                        RATE
                      </label>
                      <input type="text" id="update-product-rate" class="form-control" formControlName="updateProductRateFormControl" placeholder="Service Rate"
                             style="width: 350px;height: 40px;" />
                      <div *ngIf="updateProductFormControls.updateProductRateFormControl.hasError('required') && updateProductFormControls.updateProductRateFormControl.touched" style="color: red;font-size: 14px;">
                        Service Rate is required.
                      </div>
                    </div>

                    <div style="float: left; margin-right: 100px;" *ngIf="!isClickedAddOn()">
                      <label style="font-size: 11px;height: 15px;padding-top: 0px;padding-bottom: 0px;color: #7c7575;font-weight: bold;" for="update-product-duration">
                        DURATION
                      </label>
                      <div style="display: flex;">
                        <input disabled type="number" id="update-product-duration" formControlName="updateProductDurationFormControl" class="form-control" style="width: 150px;height: 40px; " />
                        <span style="margin-left: 15px;margin-top: 5px;">mins</span>
                      </div>
                      <!-- <div *ngIf="updateProductFormControls.updateProductDurationFormControl.hasError('required') && updateProductFormControls.updateProductDurationFormControl.touched" style="color: red;font-size: 14px;">
                          Product Duration is required.
                      </div> -->
                    </div>
                    <div *ngIf="isClickedProductSingleSession() || isClickedMultiSessionSessions()" style="float: left;">
                      <label style="font-size: 11px;height: 15px;padding-top: 0px;padding-bottom: 0px;color: #7c7575;font-weight: bold;" for="update-product-capacity-per-venue">
                        CAPACITY PER VENUE
                      </label>
                      <div style="display: flex;">
                        <button type="button"
                                (click)="decrementCapacity()"
                                style="width: 30px; height: 30px;">
                          -
                        </button>
                        <input type="number" id="update-product-capacity-per-venue" formControlName="updateProductCapacityPerVenueFormControl"
                               class="form-control"
                               style="width: 70px;height: 30px;"
                               min="1"
                               step="1"
                               (keydown)="preventDecimal($event)"/>
                        <button type="button"
                                (click)="incrementCapacity()"
                                style="width: 30px; height: 30px;">
                          +
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div style="margin-top: 20px;">
                    <div style="float: left;margin-right: 100px;">
                      <label style="font-size: 11px;height: 15px;padding-top: 0px;padding-bottom: 0px;color: #7c7575;font-weight: bold;" for="product-type">
                        TYPE
                      </label>
                      <div style="width: 350px;height: 40px; margin-top: 5px;">
                        <mat-chip-list aria-label="Product Type">
                          <mat-basic-chip *ngIf="isClickedProductSingleSession()" id="single-session" style="margin-left: 10px; cursor: pointer; padding: 5px; background-color: #DDE4E9; border: 1px solid #DAE2E8; border-radius: 4px;">Single Session</mat-basic-chip>
                          <mat-basic-chip *ngIf="isClickedProductMultiSession()" id="multi-session" style="margin-left: 10px; cursor: pointer; padding: 5px; background-color: #DDE4E9; border: 1px solid #DAE2E8; border-radius: 4px;">Multiple Sessions</mat-basic-chip>
                          <mat-basic-chip *ngIf="isClickedAddOn()" id="addon-type" style="margin-left: 10px; cursor: pointer; padding: 5px; background-color: #DDE4E9; border: 1px solid #DAE2E8; border-radius: 4px;">Add-On</mat-basic-chip>
                        </mat-chip-list>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div style="margin-left: 15px;" *ngIf="isClickedMultiSessionSessions()">
                    <div style="float: left; margin-right: 100px; margin-left: 15px;">
                      <label style="font-size: 11px;height: 15px;padding-top: 0px;padding-bottom: 0px;color: #7c7575;font-weight: bold;" for="update-product-sub-type-multi-sessions">
                        SUB TYPE
                      </label>
                      <div style="display: flex;">
                        <input disabled id="update-product-sub-type-multi-sessions" formControlName="updateProductMultiSessionSessionsFormControl" class="form-control" style="width: 150px;height: 40px; " />
                      </div>
                    </div>
                    <div style="float: left; margin-right: 100px;">
                      <label style="font-size: 11px;height: 15px;padding-top: 0px;padding-bottom: 0px;color: #7c7575;font-weight: bold;" for="update-product-sub-type-multi-sessions-no">
                        NO OF SESSIONS
                      </label>
                      <div style="display: flex;">
                        <input id="update-product-sub-type-multi-sessions-no" formControlName="updateProductMultiSessionSessionsNoFormControl" class="form-control" style="width: 150px;height: 40px; " />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div style="margin-left: 15px;" *ngIf="isClickedMultiSessionMonthly()">
                    <div style="float: left; margin-right: 100px;">
                      <label style="font-size: 11px;height: 15px;padding-top: 0px;padding-bottom: 0px;color: #7c7575;font-weight: bold;" for="update-product-sub-type-multi-monthly">
                        SUB TYPE
                      </label>
                      <div style="display: flex;">
                        <input disabled id="update-product-sub-type-multi-monthly" formControlName="updateProductMultiSessionMonthlyFormControl" class="form-control" style="width: 150px;height: 40px; " />
                      </div>
                    </div>
                    <div style="float: left; margin-right: 100px;">
                      <label style="font-size: 11px;height: 15px;padding-top: 0px;padding-bottom: 0px;color: #7c7575;font-weight: bold;" for="update-product-sub-type-multi-sessions-no">
                        NO OF MONTHS
                      </label>
                      <div style="display: flex;">
                        <input id="update-product-sub-type-multi-monthly-no" formControlName="updateProductMultiSessionMonthlyNoFormControl" class="form-control" style="width: 150px;height: 40px; " />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div style="margin-left: 15px;" *ngIf="isOpenProduct">
                    <div style="float: left; margin-right: 100px;">
                      <label style="font-size: 11px;height: 15px;padding-top: 0px;padding-bottom: 0px;color: #7c7575;font-weight: bold;" for="update-product-sub-type-multi-monthly">
                        SUB TYPE
                      </label>
                      <div style="width: 350px;height: 40px; margin-top: 5px;">
                        <mat-chip-list aria-label="Product Type">
                          <mat-basic-chip  id="open-session" style="margin-left: 10px; cursor: pointer; padding: 5px; background-color: #DDE4E9; border: 1px solid #DAE2E8; border-radius: 4px;">Flexible</mat-basic-chip>
                        </mat-chip-list>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">

                <div class="col">
                  <label *ngIf="isClickedMultiSessionMonthly()" style="font-size: 11px;height: 15px; color: #7c7575;font-weight: bold; margin-top: 20px;">
                    WHEN CUSTOMER SHALL START ?
                  </label>
                  <div *ngIf="isClickedMultiSessionMonthly()" style="margin-left: 15px;">

                    <!--<input type="radio" checked/>-->
                    <label style="font-size: 13px; margin-left: 5px;">{{clickedProductDetails.monthlyMultiBookingOption}}</label>
                    <p *ngIf="selectedOptionForMonthlyMultiBooking === radioOptionsSetForMonthlyMultiBooking[1]" style="font-size: 14px; margin-left: 15px;">
                      <input type="text" formControlName="updateSelectedDatesFormControl"
                             />

                    </p>
                    <div *ngIf="updateproductFormGroup.controls.updateSelectedDatesFormControl.errors?.pattern
                                                      && (updateproductFormGroup.controls.updateSelectedDatesFormControl.touched
                                                          || updateproductFormGroup.controls.updateSelectedDatesFormControl.dirty)"
                         style="color: red; font-size: 14px;">
                      Please enter valid dates (1–31) separated by commas only.
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div style="margin-left: 15px;" *ngIf="showMultipleBookingsOption">
                    <!--<div style="float: left;margin-right: 100px;">
                      <label style="font-size: 11px;height: 15px;padding-top: 0px;padding-bottom: 0px;color: #7c7575;font-weight: bold;" for="product-sub-type">
                        SUB TYPE 1: {{productSubTypes}}
                      </label>
                      &lt;!&ndash;<select formControlName="selectedProductSubTypeValue" class="form-control" [disabled]="true" (change)="selectValueChangeForProductSubType($event)" required>
                          &lt;!&ndash;<option *ngFor="let productSubType of productSubTypes" [value]="productSubType">&ndash;&gt;
                                  {{productSubType}}
                          &lt;!&ndash;</option>&ndash;&gt;
                      </select>&ndash;&gt;
                    </div>-->
                    <div style="float: left;">
                      <!--<div *ngIf="selectedProductSubTypeValue === productSubTypes[0]">
                        <label style="font-size: 11px;height: 15px;padding-top: 0px;padding-bottom: 0px;color: #7c7575;font-weight: bold;" for="frequency">
                          NO OF MONTHS 1
                        </label>
                        <select  id="frequency" formControlName="selectedFrequencyValue" class="form-control" >
                          <option *ngFor="let month of months" [value]="month">
                            {{month}}
                          </option>
                        </select>
                      </div>-->
                      <div *ngIf="selectedProductSubTypeValue === productSubTypes[1]">
                        <label style="font-size: 11px;height: 15px;padding-top: 0px;padding-bottom: 0px;color: #7c7575;font-weight: bold;" for="frequency">
                          NO OF SESSIONS
                        </label>
                        <input  formControlName="selectedFrequencyValue" type="number" id="duration" (change)="inputValueChangeForSessionsFrequency()" class="form-control" style="width: 100px;height: 40px;" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row" *ngIf="!isOpenProduct && !isClickedAddOn()">
                <div class="col">
                  <div> <!--*ngIf="isClickedProductSingleSession()"-->
                    <label style="font-size: 11px;height: 15px;padding-top: 15px;padding-bottom: 0px;color: #7c7575;font-weight: bold;" for="session-occurence">
                      SESSIONS
                    </label>

                    <div *ngFor="let session of clickedProductDetails.sessions; let i = index" class="session-row">

                      <mat-chip-listbox multiple>
                        <mat-chip-option class="chip_margin" *ngFor="let chip of chips" selectable="false" [selected]="isSessionSelectedOnGivenDay(chip, i)">
                          <span class="unselectableText">{{chip.charAt(0)}}</span>
                        </mat-chip-option>
                      </mat-chip-listbox>

                      <div>
                        <label class="session-field-label" for="start-time-new-product">START TIME</label>
                        <input disabled [(ngModel)]="session.startTime" [ngModelOptions]="{standalone: true}" id="sessionStartTime" class="form-control session-time-input"/>
                      </div>

                      <div>
                        <label class="session-field-label" for="facility-type">END TIME</label>
                        <input disabled [(ngModel)]="session.endTime" [ngModelOptions]="{standalone: true}" id="sessionEndTime" class="form-control session-time-input"/>
                      </div>

                      <div class="session-actions">
                        <span class="rupee" (click)="!addSessionClicked && handleExistingSessionAdvancePricing(i, session.id)"
                              [class.disabled-icon]="addSessionClicked"></span>
                        <span class="session-delete-btn" (click)="handleDeleteExistingSession(session)"
                              [class.disabled-delete]="addSessionClicked">
                          <mat-icon>delete</mat-icon>
                        </span>
                      </div>

                    </div>

                    <div *ngFor="let i of noOfSessionAddedInProductEditButNotSubmit | fill; let ind = index" style="clear: both; display: block; margin-top: 15px;">
                      <div style="float: left;margin-right: 85px;">
                        <div style="display: flex;">
                          <mat-chip-listbox style="min-width=350px; margin-top: 15px;" multiple>
                            <mat-chip-option class="chip_margin" *ngFor="let chip of productEditAddSessionChips" selectable="true" [selected]="isSelected_SingleMultiple_BookingForEditProductAddSession(chip, ind)" (click)="onClickSingleBookingChipsEditProductAddSession($event, chip, ind)">
                              <span class="unselectableText">{{chip.charAt(0)}}</span>
                            </mat-chip-option>
                          </mat-chip-listbox>
                        </div>
                      </div>

                      <!--<div style="float: left; margin-right: 30px;">
                        <label style="font-size: 11px;height: 15px;padding-top: 0px;padding-bottom: 0px;color: #7c7575;font-weight: bold;" for="start-time-edit-product-single-booking-add-session">
                          START TIME
                        </label>
                        <select #selectStartTimeSingleBookingEditProduct required id="start-time-edit-product-single-booking-add-session" formControlName="startTimeForSingleSessionEditProductFormContol" (change)="selectValueChangeForStartTime(selectStartTimeSingleBookingEditProduct.value, ind)" class="form-control" style="width: 120px">
                          <option *ngFor="let startTimeOption of startTimeOptions" [value]="startTimeOption">
                            {{startTimeOption}}
                          </option>
                        </select>
                      </div>-->
                      <div style="float: left; margin-right: 30px;">
                        <label
                          style="font-size: 11px;height: 15px;padding-top: 0px;padding-bottom: 0px;color: #7c7575;font-weight: bold;"
                          for="start-time-edit-product-single-booking-add-session">
                          START TIME
                        </label>

                        <select
                          #selectStartTimeSingleBookingEditProduct
                          required
                          id="start-time-edit-product-single-booking-add-session"
                          [ngModel]="selectedStartTimeValue[ind]"
                          (ngModelChange)="selectValueChangeForStartTime($event, clickedProductDetails.sessions.length + ind)"
                          [ngModelOptions]="{standalone: true}"
                          class="form-control"
                          style="width: 120px">

                          <option *ngFor="let startTimeOption of startTimeOptions"
                                  [value]="startTimeOption">
                            {{startTimeOption}}
                          </option>

                        </select>
                      </div>

                      <!--<div style="float: left; margin-right: 50px;">
                        <label style="font-size: 11px;height: 15px;padding-top: 0px;padding-bottom: 0px;color: #7c7575;font-weight: bold;" for="end-time-edit-product-single-booking-add-session">
                          END TIME
                        </label>
                        <select #selectEndTimeMultiBookingEditProduct required id="end-time-edit-product-single-booking-add-session" formControlName="endTimeForSingleSessionEditProductFormContol" (change)="selectValueChangeForEndTime(selectEndTimeMultiBookingEditProduct.value, ind)" class="form-control" style="width: 120px">
                          <option *ngFor="let endTimeOption of filteredEndTimeOptions" [value]="endTimeOption">
                            {{endTimeOption}}
                          </option>
                        </select>
                      </div>-->
                      <div style="float: left; margin-right: 50px;">
                        <label
                          style="font-size: 11px;height: 15px;padding-top: 0px;padding-bottom: 0px;color: #7c7575;font-weight: bold;"
                          for="end-time-edit-product-single-booking-add-session">
                          END TIME
                        </label>

                        <select
                          #selectEndTimeMultiBookingEditProduct
                          required
                          id="end-time-edit-product-single-booking-add-session"
                          [ngModel]="selectedEndTimeValue[ind]"
                          (ngModelChange)="selectValueChangeForEndTime($event, clickedProductDetails.sessions.length + ind)"
                          [ngModelOptions]="{standalone: true}"
                          class="form-control"
                          style="width: 120px">

                          <option *ngFor="let endTimeOption of filteredEndTimeOptions"
                                  [value]="endTimeOption">
                            {{endTimeOption}}
                          </option>

                        </select>
                      </div>

                      <div style="float: left; margin-top: 35px;">
                        <!-- <label style="font-size: 11px;height: 15px;padding-top: 0px;padding-bottom: 0px;color: #7c7575;font-weight: bold; margin-left: 10px;" for="session-actions">
                            ACTIONS
                        </label> -->
                        <div>
                          <span class="rupee" (click)="clickedAdvancedPricing(clickedProductDetails.sessions.length + ind)" ></span>
                          <span *ngIf=" ind != 0" (click)="clickedDeleteActionsSingleBooking(ind)" style="display: inline-block; cursor: pointer;">
                                                    <mat-icon>delete</mat-icon>
                                                </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row" *ngIf="!isOpenProduct && !addSessionClicked && !isClickedAddOn()">
                <div class="col">
                  <div style="margin-top: 20px;">
                    <div style="float: left;margin-right: 30px;">
                      <button class="btn btn-primary" type="button" (click)="addSessionForProductEdit()" for="single_multiple-booking-add-new-session" style="background-color: #ffffff;color: #14274e;width: 100px;height: 30px;padding: 0px;font-size: 14px;float: right;margin-left: 15px;border-color: #14274E;">
                        Add Session
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div style="margin-top: 20px; display: flex; gap: 60px; align-items: flex-start; flex-wrap: wrap;">

                    <!-- Status Toggle -->
                    <div>
                      <label style="font-size: 11px;color: #7c7575;font-weight: bold;" for="product-status">
                        STATUS
                      </label>
                      <br />
                      <span style="font-size: 12px;color: #7c7575;">
                        Inactive services are NOT visible to the customers for booking but admin can access it.
                      </span>
                      <div style="display: flex;">
                        <mat-slide-toggle
                          [(ngModel)]="isChecked"
                          [ngModelOptions]="{standalone: true}"
                          class="example-margin"
                          [color]="color"
                          [checked]="checked"
                          [disabled]="disabled">
                          {{getProductStatusValue()}}
                        </mat-slide-toggle>
                      </div>
                    </div>

                    <!-- Allow Booking Toggle -->
                    <div *ngIf="!isClickedAddOn()">
                      <label class="toggle-label">ALLOW BOOKING</label>
                      <div class="toggle-wrapper">
                        <mat-slide-toggle formControlName="updateAllowBookingFormControl" [color]="color">
                          {{ updateproductFormGroup.get('updateAllowBookingFormControl').value ? 'Yes' : 'No' }}
                        </mat-slide-toggle>
                      </div>
                    </div>

                    <!-- Is Coaching Toggle -->
                    <div *ngIf="!isClickedAddOn()">
                      <label class="toggle-label">IS COACHING</label>
                      <div class="toggle-wrapper">
                        <mat-slide-toggle formControlName="updateIsCoachingFormControl" [color]="color">
                          {{ updateproductFormGroup.get('updateIsCoachingFormControl').value ? 'Yes' : 'No' }}
                        </mat-slide-toggle>
                      </div>
                    </div>

                  </div>
                </div>
              </div>

              <!-- Single-session booking window -->
              <div class="row" *ngIf="isClickedProductSingleSession()">
                <div class="col">
                  <div style="margin-top: 20px;">
                    <label class="toggle-label">BOOKING WINDOW</label>
                    <br />
                    <span style="font-size: 12px;color: #7c7575;">How far in advance customers can book this service.</span>
                    <div style="margin-top: 8px;">
                      <label style="display:block; font-size: 13px; color:#14274e;">
                        <input type="radio" formControlName="updateBookingWindowTypeFormControl" value="RollingDays" />
                        Allow for next
                        <input type="number" min="1" formControlName="updateBookingWindowDaysFormControl"
                               class="form-control d-inline-block" style="width: 70px; margin: 0 6px;" />
                        days
                      </label>
                      <label style="display:block; font-size: 13px; color:#14274e; margin-top: 8px;">
                        <input type="radio" formControlName="updateBookingWindowTypeFormControl" value="UptoDate" />
                        Allow bookings up to
                        <input type="date" formControlName="updateBookingWindowUptoDateFormControl"
                               class="form-control d-inline-block" style="width: 160px; margin-left: 6px;" />
                      </label>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </form>
        </div>
      </div>
    </div>

    <div *ngIf="showAddNewProductForm">
      <div class="row" style="margin-top: 20px;">
        <div class="col">
          <form [formGroup]="productFormGroup">
            <div class="form-group">
              <div>
                <p class="admin-string-primary" style="margin-top: 20px">
                  NEW SERVICE
                  <button class="btn btn-primary" (click)="onCreateProductFormSaveClicked()" type="button" style="background-color: #ffffff;color: #7c7575;width: 66px;height: 30px;padding: 0px;font-size: 14px;float: right;margin-right: 0px;border-color: #14274E;">
                    Save
                  </button>
                  <button class="btn btn-primary" (click)="onCreateProductFormCancelClicked()" type="button" style="background-color: #ffffff;color: #14274e;width: 66px;height: 30px;padding: 0px;font-size: 14px;float: right;margin-right: 30px;border: none;border-color: #14274E;">
                    Cancel
                  </button>
                </p>
                <hr style="background-color: #D8DFE6;" />
              </div>
              <div class="row">
                <div class="col">
                  <div>
                    <div style="float: left;margin-right: 100px;">
                      <label style="font-size: 11px;height: 15px;padding-top: 0px;padding-bottom: 0px;color: #7c7575;font-weight: bold;" for="product-name">
                        SERVICE NAME
                      </label>
                      <input type="text" id="product-name" class="form-control" formControlName="productNameFormControl" placeholder="Service Name"
                             style="width: 350px;height: 40px;" />
                      <div *ngIf="productFormControls.productNameFormControl.hasError('required') && productFormControls.productNameFormControl.touched" style="color: red;font-size: 14px;">
                        Service Name is required.
                      </div>
                    </div>

                    <div style="float: left;margin-right: 100px;">
                      <label style="font-size: 11px;height: 15px;padding-top: 0px;padding-bottom: 0px;color: #7c7575;font-weight: bold;" for="product-description">
                        SERVICE DESCRIPTION
                      </label>
                      <textarea id="product-description" class="form-control" formControlName="productDescriptionFormControl" placeholder="Service Description" rows="2"
                                style="width: 350px;">
                                        </textarea>
                      <div *ngIf="productFormControls.productDescriptionFormControl.hasError('required') && productFormControls.productDescriptionFormControl.touched" style="color: red;font-size: 14px;">
                        Service Description is required.
                      </div>
                    </div>

                    <div style="float: left;" *ngIf="!showAddOnOption">
                      <label class="field-label" for="service-type">
                        SERVICE TYPE <span class="required-star">*</span>
                      </label>
                      <select id="service-type" formControlName="serviceTypeFormControl" class="form-control service-type-select">
                        <option value="">-- Select --</option>
                        <option *ngFor="let service of serviceTypes" [value]="service.value">{{ service.label }}</option>
                      </select>
                      <div class="validation-error" *ngIf="productFormControls.serviceTypeFormControl.hasError('required') && productFormControls.serviceTypeFormControl.touched">
                        Service Type is required.
                      </div>
                    </div>
                    <!-- <div style="float: left;">
                        <label style="font-size: 11px;height: 15px;padding-top: 0px;padding-bottom: 0px;color: #7c7575;font-weight: bold;" for="product-id">
                            PRODUCT ID
                        </label>
                        <input disabled type="text" id="product-id" class="form-control" placeholder="Product ID"
                            style="width: 350px;height: 40px;" />
                    </div> -->
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div style="margin-top: 20px;">
                    <div style="float: left;margin-right: 100px;">
                      <label style="font-size: 11px;height: 15px;padding-top: 0px;padding-bottom: 0px;color: #7c7575;font-weight: bold;" for="product-rate">
                        RATE
                      </label>
                      <input type="number" id="product-rate" class="form-control" formControlName="productRateFormControl" placeholder="Service Rate"
                             style="width: 350px;height: 40px;" min="0"
                             step="1" />
                      <div *ngIf="productFormControls.productRateFormControl.hasError('pattern')
                              && productFormControls.productRateFormControl.touched"
                           style="color: red; font-size: 14px;">
                        Please enter a valid numeric value.
                      </div>
                    </div>

                    <div style="float: left; margin-right: 100px;" *ngIf="!showAddOnOption">
                      <label style="font-size: 11px;height: 15px;padding-top: 0px;padding-bottom: 0px;color: #7c7575;font-weight: bold;" for="duration">
                        DURATION
                      </label>
                      <div style="display: flex;">
                        <input type="number" id="duration" formControlName="productDurationFormControl" class="form-control" style="width: 150px;height: 40px;" />
                        <span style="margin-left: 15px;margin-top: 5px;">mins</span>
                      </div>
                    </div>
                    <!--  -->
                    <!--<div *ngIf="showSingleBookingsOption &lt;!&ndash;|| selectedProductSubTypeValue === productSubTypes[1]&ndash;&gt;" style="float: left;">-->

                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div style="margin-top: 20px;">
                    <div style="float: left;margin-right: 100px;">
                      <label style="font-size: 11px;height: 15px;padding-top: 0px;padding-bottom: 0px;color: #7c7575;font-weight: bold;" for="product-type">
                        TYPE
                      </label>
                      <div style="width: 350px;height: 40px; margin-top: 5px;">
                        <mat-chip-list aria-label="Product Type">
                          <mat-basic-chip *ngIf="!sessionTypeSelected || sessionTypeSelected === 'single'"
                                          id="single-session"
                                          style="margin-left: 10px; cursor: pointer; padding: 5px; background-color: #DDE4E9; border: 1px solid #DAE2E8; border-radius: 4px;"
                                          (click)="productTypeChipsClickedSingleBooking()"
                                          [style.pointer-events]="sessionTypeSelected && sessionTypeSelected !== 'single' ? 'none' : 'auto'">Single Session</mat-basic-chip>
                          <mat-basic-chip *ngIf="!sessionTypeSelected || sessionTypeSelected === 'multi'"
                                          id="multi-session"
                                          style="margin-left: 10px; cursor: pointer; padding: 5px; background-color: #DDE4E9; border: 1px solid #DAE2E8; border-radius: 4px;"
                                          (click)="productTypeChipsClickedMultipleBooking()"
                                          [style.pointer-events]="sessionTypeSelected && sessionTypeSelected !== 'multi' ? 'none' : 'auto'">Multi-Session</mat-basic-chip>
                          <mat-basic-chip *ngIf="!sessionTypeSelected || sessionTypeSelected === 'addOn'"
                                          id="addon-type"
                                          [class.selected-chip]="sessionTypeSelected === 'addOn'"
                                          style="margin-left: 10px; cursor: pointer; padding: 5px; background-color: #DDE4E9; border: 1px solid #DAE2E8; border-radius: 4px;"
                                          (click)="productTypeChipsClickedAddOn()"
                                          [style.pointer-events]="sessionTypeSelected && sessionTypeSelected !== 'addOn' ? 'none' : 'auto'">Add-On</mat-basic-chip>
                        </mat-chip-list>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="showMultipleBookingsOption">
                <div class="col">
                  <div style="margin-left: 15px;">
                    <div style="float: left;margin-right: 100px;">
                      <label style="font-size: 11px;height: 15px;padding-top: 0px;padding-bottom: 0px;color: #7c7575;font-weight: bold;" for="product-sub-type">
                        SUB TYPE
                      </label>
                      <select [(ngModel)]="selectedProductSubTypeValue" id="product-sub-type" formControlName="selectedProductSubTypeValue" class="form-control" (change)="selectValueChangeForProductSubType($event)" required>
                        <option *ngFor="let productSubType of productSubTypes" [value]="productSubType">
                          {{productSubType}}
                        </option>
                      </select>
                    </div>
                    <div style="float: left;">
                      <div *ngIf="selectedProductSubTypeValue === productSubTypes[0]">
                        <label style="font-size: 11px;height: 15px;padding-top: 0px;padding-bottom: 0px;color: #7c7575;font-weight: bold;" for="frequency">
                          NO OF MONTHS
                        </label>
                        <select  id="frequency"
                                formControlName="selectedFrequencyValue"
                                class="form-control"
                                min="1"
                                step="1"
                                (keydown)="preventDecimal($event)">
                          <option *ngFor="let month of months" [value]="month">
                            {{month}}
                          </option>
                        </select>
                      </div>
                      <!--<div *ngIf="selectedProductSubTypeValue === productSubTypes[1]">
                          <label style="font-size: 11px;height: 15px;padding-top: 0px;padding-bottom: 0px;color: #7c7575;font-weight: bold;" for="frequency">
                              No of Sessions
                          </label>
                          <input  formControlName="selectedFrequencyValue" type="number" id="duration" (change)="inputValueChangeForSessionsFrequency()" class="form-control" style="width: 100px;height: 40px;" />
                      </div>-->
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="showMultipleBookingsOption">
                <div class="col" *ngIf="selectedProductSubTypeValue === productSubTypes[0]">
                  <div  style="margin-top: 40px;">
                    <div class="form-group">
                      <label style="font-size: 11px;height: 15px;padding-top: 0px;padding-bottom: 0px;color: #7c7575;font-weight: bold;">
                        WHEN CUSTOMER SHALL START ?
                      </label>
                      <div style="margin-left: 15px;" *ngFor="let option of radioOptionsSetForMonthlyMultiBooking">
                                          <span>
                                              <input type="radio"  [(ngModel)]="selectedOptionForMonthlyMultiBooking" [ngModelOptions]="{standalone: true}" [value]="option"/>
                                              <label style="font-size: 13px; margin-left: 5px;">{{option}}</label>
                                            </span>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="selectedOptionForMonthlyMultiBooking === radioOptionsSetForMonthlyMultiBooking[1]">
                    <p style="font-size: 14px;">
                      Enter comma separated dates of the month. (e.g. 1,15) =>
                      <input type="text" [required]="getIsSelectedDateRequired" formControlName="selectedDatesFormControl"
                             pattern="^([1-9]|[12][0-9]|3[01])(,([1-9]|[12][0-9]|3[01]))*$"
                             ... />
                      <!--style="/*border-top: none;*//*border-right: none;*//*border-left: none;*/outline: 0;border: none;border-bottom: 1px solid black;width: 400px;" />-->
                    </p>
                    <div *ngIf="getIsSelectedDateRequired" style="color: red;font-size: 14px;">
                      Selected dates are required.
                    </div>
                    <div *ngIf="productFormGroup.controls.selectedDatesFormControl.errors?.pattern
                                              && (productFormGroup.controls.selectedDatesFormControl.touched
                                                  || productFormGroup.controls.selectedDatesFormControl.dirty)"
                         style="color: red; font-size: 14px;">
                      Please enter valid dates (1–31) separated by commas only.
                    </div>

                  </div>
                </div>
              </div>
              <div class="row" style="margin-top: 20px;">
                <div class="col"   *ngIf="showSingleBookingsOption" >
                <label style="font-size: 11px;height: 15px;color: #7c7575;font-weight: bold;" for="capacity-per-venue">
                  CAPACITY PER VENUE
                </label>
                <div style="display: flex;">
                  <button type="button"
                          (click)="decrementCapacity()"
                          style="width: 30px; height: 30px;">
                    -
                  </button>
                  <input type="number" [required]="isCapacityPerVenueRequired" id="capacity-per-venue"
                         formControlName="productCapacityPerVenueFormControl"
                         class="form-control" style="width: 50px;height: 30px;"
                         min="1"
                         step="1"
                         (keydown)="preventDecimal($event)"
                  />
                  <button type="button"
                          (click)="incrementCapacity()"
                          style="width: 30px; height: 30px;">
                    +
                  </button>

                </div>
                <div *ngIf="getCapacityPerVenueRequired() && productFormControls.productCapacityPerVenueFormControl.touched" style="color: red;font-size: 14px;">
                  Capacity Per Venue is required.
                </div>
              </div>
              </div>
              <div class="row single-multiple-bookingsS" style="margin-top: 15px;">
                <div class="col" *ngIf="canShowSessions">
                  <label style="font-size: 11px;height: 15px;color: #7c7575;font-weight: bold;" for="session-occurence">
                    SESSIONS
                  </label>
                  <!-- MULTIPLE BOOKINGS -->
                  <div *ngIf="showMultipleBookingsOption && selectedProductSubTypeValue !== undefined" style="margin-top: 10px;">
                    <div *ngFor="let i of noOfSessionsToDisplay | fill; let ind = index" style="display: flex; align-items: flex-start; gap: 30px; margin-bottom: 10px; flex-wrap: wrap;">
                      <!-- Session and Chips -->
                      <div style="display: flex; align-items: center; gap: 20px;">
                        <!--                                <span style="margin-left: 15px; margin-top: 15px;">SessionB {{ind + 1}}</span>-->
                        <mat-chip-listbox style="min-width: 400px; margin-top: 15px;" multiple>
                          <mat-chip-option class="chip_margin" *ngFor="let chip of chips" selectable="true"
                                           [selected]="isSelectedMultiBooking(chip, ind)"
                                           (click)="onClickMultiBookingChips($event, chip, ind)">
                            <span class="unselectableText">{{chip.charAt(0)}}</span>
                          </mat-chip-option>
                        </mat-chip-listbox>
                      </div>

                      <!-- Start Time -->
                      <!--<div>
                        <label style="font-size: 11px; color: #7c7575; font-weight: bold;" for="start-time-new-product">
                          START TIME
                        </label>
                        <select #selectStartTime required id="start-time-new-product"
                                formControlName="startTimeForSingleSessionFormContol"
                                (change)="selectValueChangeForStartTime(selectStartTime.value, ind)" class="form-control"
                                style="width: 120px;">
                          <option *ngFor="let startTimeOption of startTimeOptions" [value]="startTimeOption">
                            {{startTimeOption}}
                          </option>
                        </select>
                      </div>-->
                      <div style="float: left; margin-right: 30px;">
                        <label
                          style="font-size: 11px;height: 15px;padding-top: 0px;padding-bottom: 0px;color: #7c7575;font-weight: bold;"
                          for="start-time-edit-product-single-booking-add-session">
                          START TIME
                        </label>

                        <select
                          #selectStartTimeSingleBookingEditProduct
                          required
                          id="start-time-edit-product-single-booking-add-session"
                          [ngModel]="selectedStartTimeValue[ind]"
                          (ngModelChange)="selectValueChangeForStartTime($event, ind)"
                          [ngModelOptions]="{standalone: true}"
                          class="form-control"
                          style="width: 120px">

                          <option *ngFor="let startTimeOption of startTimeOptions"
                                  [value]="startTimeOption">
                            {{startTimeOption}}
                          </option>

                        </select>
                      </div>

                      <!-- End Time -->
                      <!--<div>
                        <label style="font-size: 11px; color: #7c7575; font-weight: bold;" for="facility-type">
                          END TIME
                        </label>
                        <select #selectEndTime required id="facility-type"
                                formControlName="endTimeForSingleSessionFormContol"
                                (change)="selectValueChangeForEndTime(selectEndTime.value, ind)" class="form-control"
                                style="width: 120px;">
                          <option *ngFor="let endTimeOption of filteredEndTimeOptions" [value]="endTimeOption">
                            {{endTimeOption}}
                          </option>
                        </select>
                      </div>-->
                      <div style="float: left; margin-right: 50px;">
                        <label
                          style="font-size: 11px;height: 15px;padding-top: 0px;padding-bottom: 0px;color: #7c7575;font-weight: bold;"
                          for="end-time-edit-product-single-booking-add-session">
                          END TIME
                        </label>

                        <select
                          #selectEndTimeMultiBookingEditProduct
                          required
                          id="end-time-edit-product-single-booking-add-session"
                          [ngModel]="selectedEndTimeValue[ind]"
                          (ngModelChange)="selectValueChangeForEndTime($event, ind)"
                          [ngModelOptions]="{standalone: true}"
                          class="form-control"
                          style="width: 120px">

                          <option *ngFor="let endTimeOption of filteredEndTimeOptions"
                                  [value]="endTimeOption">
                            {{endTimeOption}}
                          </option>

                        </select>
                      </div>

                      <!-- Actions -->
                      <div style="margin-top: 25px;">
                        <span class="rupee" (click)="clickedAdvancedPricing(ind)"></span>
                        <span (click)="clickedDeleteActionsSingleBooking(ind)" style="cursor: pointer;">
                                  <mat-icon>delete</mat-icon>
                                </span>
                      </div>
                    </div>
                  </div>

                  <!-- SINGLE BOOKINGS -->
                  <div *ngIf="showSingleBookingsOption" style="margin-top: 10px;">
                    <div *ngFor="let i of noOfSessionsToDisplay | fill; let ind = index" style="display: flex; align-items: flex-start; gap: 30px; margin-bottom: 15px; flex-wrap: wrap;">

                      <!-- Session and Chips -->
                      <div style="display: flex; align-items: center; gap: 20px;">
                        <!--<span style="margin-left: 15px; margin-top: 15px;">SessionA {{ind + 1}}</span>-->
                        <mat-chip-listbox style="min-width: 400px; margin-top: 15px;" multiple>
                          <mat-chip-option class="chip_margin" *ngFor="let chip of chips" selectable="true"
                                           [selected]="isSelectedSingleBooking(chip, ind)"
                                           (click)="onClickSingleBookingChips($event, chip, ind)">
                            <span class="unselectableText">{{chip.charAt(0)}}</span>
                          </mat-chip-option>
                        </mat-chip-listbox>
                      </div>

                      <!-- Start Time -->
                      <div>
                        <label style="font-size: 11px; color: #7c7575; font-weight: bold;" for="start-time-new-product-single-booking">
                          START TIME
                        </label>
                        <select #selectStartTimeSingleBooking required id="start-time-new-product-single-booking"
                                formControlName="startTimeForSingleSessionFormContol"
                                (change)="selectValueChangeForStartTime(selectStartTimeSingleBooking.value, ind)" class="form-control"
                                style="width: 120px;">
                          <option *ngFor="let startTimeOption of startTimeOptions" [value]="startTimeOption">
                            {{startTimeOption}}
                          </option>
                        </select>
                      </div>

                      <!-- End Time -->
                      <div>
                        <label style="font-size: 11px; color: #7c7575; font-weight: bold;" for="start-time-new-product-multi-booking">
                          END TIME
                        </label>
                        <select #selectEndTimeMultiBooking required id="start-time-new-product-multi-booking"
                                formControlName="endTimeForSingleSessionFormContol"
                                (change)="selectValueChangeForEndTime(selectEndTimeMultiBooking.value, ind)" class="form-control"
                                style="width: 120px;">
                          <option *ngFor="let endTimeOption of filteredEndTimeOptions" [value]="endTimeOption">
                            {{endTimeOption}}
                          </option>
                        </select>
                      </div>

                      <!-- Actions -->
                      <div style="margin-top: 25px;">
                        <span class="rupee" (click)="clickedAdvancedPricing(ind)"></span>
                        <span (click)="clickedDeleteActionsSingleBooking(ind)" style="cursor: pointer;">
                                    <mat-icon>delete</mat-icon>
                                </span>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              <div class="row" *ngIf="(showSingleBookingsOption || showMultipleBookingsOption) && canShowSessions && !addSessionClicked">
                <div class="col">
                  <div style="margin-top: 10px;">
                    <div style="float: left;margin-right: 30px;">
                      <button class="btn btn-primary" type="button"
                              (click)="addSession(noOfSessionsToDisplay)"
                              [disabled]="!canShowSessions"
                              for="single_multiple-booking-add-new-session" style="background-color: #ffffff;color: #14274e;width: 80px;height: 25px;padding: 0px;font-size: 12px;float: right;margin-left: 15px;border-color: #14274E;">
                        Add Session
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Single-session booking window -->
              <div class="row" *ngIf="showSingleBookingsOption">
                <div class="col">
                  <div style="margin-top: 20px;">
                    <label class="toggle-label">BOOKING WINDOW</label>
                    <br />
                    <span style="font-size: 12px;color: #7c7575;">How far in advance customers can book this service.</span>
                    <div style="margin-top: 8px;">
                      <label style="display:block; font-size: 13px; color:#14274e;">
                        <input type="radio" formControlName="bookingWindowTypeFormControl" value="RollingDays" />
                        Allow for next
                        <input type="number" min="1" formControlName="bookingWindowDaysFormControl"
                               class="form-control d-inline-block" style="width: 70px; margin: 0 6px;" />
                        days
                      </label>
                      <label style="display:block; font-size: 13px; color:#14274e; margin-top: 8px;">
                        <input type="radio" formControlName="bookingWindowTypeFormControl" value="UptoDate" />
                        Allow bookings up to
                        <input type="date" formControlName="bookingWindowUptoDateFormControl"
                               class="form-control d-inline-block" style="width: 160px; margin-left: 6px;" />
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <div style="margin-top: 20px; display: flex; gap: 60px; align-items: flex-start; flex-wrap: wrap;">

                    <!-- Status Toggle -->
                    <div>
                      <label style="font-size: 11px;height: 15px;padding-top: 0px;padding-bottom: 0px;color: #7c7575;font-weight: bold;" for="product-status">
                        STATUS
                      </label>
                      <br />
                      <span style="font-size: 12px;color: #7c7575;">
                                        Inactive services are NOT visible to the customers for booking but admin can access it.
                                        </span>
                      <div style="display: flex;">
                        <mat-slide-toggle
                          [(ngModel)]="isChecked"
                          [ngModelOptions]="{standalone: true}"
                          class="example-margin"
                          [color]="color"
                          [checked]="checked"
                          [disabled]="disabled">
                          {{getProductStatusValue()}}
                        </mat-slide-toggle>
                      </div>
                    </div>

                    <!-- Allow Booking Toggle -->
                    <div *ngIf="!showAddOnOption">
                      <label class="toggle-label">ALLOW BOOKING</label>
                      <div class="toggle-wrapper">
                        <mat-slide-toggle formControlName="allowBookingFormControl" [color]="color">
                          {{ productFormGroup.get('allowBookingFormControl').value ? 'Yes' : 'No' }}
                        </mat-slide-toggle>
                      </div>
                    </div>

                    <!-- Is Coaching Toggle -->
                    <div *ngIf="!showAddOnOption">
                      <label class="toggle-label">IS COACHING</label>
                      <div class="toggle-wrapper">
                        <mat-slide-toggle formControlName="isCoachingFormControl" [color]="color">
                          {{ productFormGroup.get('isCoachingFormControl').value ? 'Yes' : 'No' }}
                        </mat-slide-toggle>
                      </div>
                    </div>

                  </div>
                </div>
              </div>

            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #content let-modal>
  <div class="modal-header" >
    <h4 class="modal-title" id="modal-basic-title" style="font-size: 14px; font-weight:bold; color: #14274E;">Advance Pricing</h4>
  </div>
  <div class="modal-body advance-pricing-body">

    <div
      *ngFor="let timeSlot of timeSlotsToShowInModalPopup; let j = index; last as isLast">

      <div *ngIf="!isLast" class="pricing-grid-row">

        <div class="pricing-cell">
          <label>START</label>
          <input
            class="form-control"
            [value]="timeSlot"
            disabled>
        </div>

        <div class="pricing-cell">
          <label>END</label>
          <input
            class="form-control"
            [value]="timeSlotsToShowInModalPopup[getNextIndexForTimeSlotsInModalPopup(j)]"
            disabled>
        </div>

        <div class="pricing-cell price-cell">
          <label>PRICE</label>
          <input
            type="number"
            class="form-control"
            [(ngModel)]="advancePricing[advanceModalPopupOpenedIndex][j]">
        </div>

      </div>

    </div>

  </div>
  <!--<div class="modal-body">
    <div class="row" *ngFor="let timeSlot of timeSlotsToShowInModalPopup; let j = index; last as isLast;">
      <div *ngIf="!isLast" class="advance-pricing-row">

        <div class="advance-time">
          <h6>START TIME</h6>
          <input class="form-control" [value]="timeSlot" disabled />
        </div>

        <div class="advance-time">
          <h6>END TIME</h6>
          <input class="form-control"
                 [value]="timeSlotsToShowInModalPopup[getNextIndexForTimeSlotsInModalPopup(j)]"
                 disabled />
        </div>

        <div class="advance-price">
          <h6>PRICE</h6>
          <input
            type="number"
            [(ngModel)]="advancePricing[advanceModalPopupOpenedIndex][j]"
            class="form-control advance-cost" />
        </div>

      </div>

    </div>
  </div>-->
  <div class="modal-footer" style="width: 350px;">
    <button class="btn btn-primary" (click)="onAdvancePricingCancelClicked()" type="button" style="background-color: #ffffff;color: #14274e;width: 66px;height: 30px;padding: 0px;font-size: 14px;float: right;margin-right: 30px;border: none;border-color: #14274E;">
      Cancel
    </button>
    <button class="btn btn-primary" (click)="onAdvancePricingSaveClicked()" type="button" style="background-color: #ffffff;color: #7c7575;width: 66px;height: 30px;padding: 0px;font-size: 14px;float: right;margin-right: 0px;border-color: #14274E;">
      Save
    </button>
  </div>
</ng-template>
<ng-template #advancePricingModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title" style="font-size: 14px; color: #7C7575;">Alert</h4>
  </div>

  <div class="modal-body">
    <div class="row">
      On clicking okay advance pricing is overwritten.
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-primary" (click)="onCancelClick()" type="button" style="background-color: #ffffff;color: #14274e;width: 66px;height: 30px;padding: 0px;font-size: 14px;float: right;margin-right: 30px;border: none;border-color: #14274E;">
      Cancel
    </button>
    <button class="btn btn-primary" (click)="onOKClick()" type="button" style="background-color: #ffffff;color: #7c7575;width: 66px;height: 30px;padding: 0px;font-size: 14px;float: right;margin-right: 0px;border-color: #14274E;">
      Okay
    </button>
  </div>
</ng-template>
